import {Box} from "@mui/material";
import theme from "theme/theme";
import React from "react";
import {SystemIcons} from "assets/icons/system/system.index";
import RejectedOverlay from "./RejectedOverlay";

interface RejectedDocumentPreviewProps {
  id?: string;
  iconSize: number;
  onClick: () => void;
  title?: string;
}

function RejectedDocumentPreview(props: RejectedDocumentPreviewProps) {
  const {id = "n", iconSize, onClick, title = ""} = props;
  return (
    <Box
      title={title}
      id={`rejected-document-preview-${id}`}
      style={{
        display: "grid",
        placeItems: "center",
        height: 64,
        backgroundColor: theme.palette.background.swiftDefault,
        borderRadius: 2,
        maxWidth: 64
      }}
      className="file-preview-item"
      position="relative"
      width="inherit"
      height="inherit"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <SystemIcons.Document width={iconSize} height={iconSize}/>
      <RejectedOverlay/>
    </Box>
  )
}

export default RejectedDocumentPreview;